<template>
    <b-dropdown dropdown :id=code variant="link"
      size="lg" offset="-14" no-flip
      no-caret menu-class='scrollable-menu' v-bind:class="{ 'sub-category': true, 'col-sm-3': true, 'mt-2': true, 'dishes-chosen': hasChosenDishes}" >
      <template slot="button-content">
        <span class="float-left sub-category-title"><h6>{{name}}</h6></span>
        <span class="float-right">
          <font-awesome-icon icon="bars" />
        </span>
      </template>
      <b-dropdown-item
        is="Dish"
        v-for="(dish, idx) in dishes"
        v-bind:key="`${randomKey}-${dish.code}`"
        v-bind:code="dish.code"
        v-bind:name="dish.name"
        v-bind:idx="idx"
        v-on:dish:choose="chooseDish"
        >
      </b-dropdown-item>
    </b-dropdown>
  <!-- </div> -->
</template>

<script>
import Dish from './Dish'
import { SubCategoryListUI } from '../lang/vn.js'
import { DishesData } from '../data/data.js'

export default {
  name: 'SubCategory',
  components: {
    Dish
  },
  props: {
    name: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      randomKey: Math.random(),
      hasChosenDishes: false,
      dishes: DishesData[this.code],
      chosenDishes: {},
      numberDishes: 0,
      subCategoryListUI: SubCategoryListUI
    }
  },
  methods: {
    chooseDishes: function () {
      let chosenDishes = []

      this.hasChosenDishes = false
      for (var i = this.dishes.length - 1; i >= 0; i--) {
        if (this.dishes[i].count > 0) {
          chosenDishes[chosenDishes.length] = {...this.dishes[i]}
          this.hasChosenDishes = true
        }
      }

      this.$emit('dishes:choose', this.chosenDishes)
    },
    chooseDish: function (idx, count) {
      let dish = {...this.dishes[idx]}
      dish['count'] = count
      this.chosenDishes[dish['code']] = dish

      this.hasChosenDishes = false
      if (count > 0) {
        this.numberDishes++
      } else {
        this.numberDishes--
      }

      if (this.numberDishes > 0) {
        this.hasChosenDishes = true
      }

      this.$emit('dishes:choose', this.chosenDishes)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SubCategory.vue